import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCameraOff1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCameraOff1"><Path fillRule="evenodd" clipRule="evenodd" d="M22.3088 21.25L2.74816 1.68933L1.6875 2.74999L4.93751 6H1.99805V21H19.9375L21.2482 22.3106L22.3088 21.25ZM14.1768 15.2393C13.579 15.7155 12.8217 16 11.998 16C10.0651 16 8.49805 14.433 8.49805 12.5C8.49805 11.6763 8.78258 10.9191 9.25873 10.3212L14.1768 15.2393Z" fill="currentColor"/><Path d="M21.998 6V18.8188L7.92969 4.75045L9.09666 3H14.8994L16.8994 6H21.998Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCameraOff1;
